import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { login, error } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const handle = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const ok = await login(email, password);
    setSubmitting(false);
    if (ok) nav(loc.state?.from?.pathname || "/feed", { replace: true });
  };

  return (
    <div data-testid="login-page" className="min-h-[70vh] px-6 md:px-12 py-16 grid md:grid-cols-2 gap-12 max-w-6xl mx-auto items-center">
      <div>
        <div className="font-mono-acc text-xs text-secondary">// ACCESS PANEL</div>
        <h1 className="font-display text-5xl md:text-6xl mt-4">Log <span className="text-primary">in</span>.</h1>
        <p className="text-muted-foreground mt-4 max-w-md">Back in the booth. Pick up where you dropped off.</p>
      </div>
      <form onSubmit={handle} className="border border-border bg-card p-8 space-y-4">
        <label className="block">
          <span className="font-mono-acc text-[10px] text-muted-foreground">Email</span>
          <input
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full bg-input border border-border px-3 py-3 outline-none focus:border-primary"
            required
          />
        </label>
        <label className="block">
          <span className="font-mono-acc text-[10px] text-muted-foreground">Password</span>
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full bg-input border border-border px-3 py-3 outline-none focus:border-primary"
            required
          />
        </label>
        {error && <p data-testid="login-error" className="text-primary text-sm font-mono-acc text-[11px]">{error}</p>}
        <button
          data-testid="login-submit"
          disabled={submitting}
          className="w-full border border-primary bg-primary text-white py-3 font-mono-acc text-xs hover:bg-white hover:text-primary disabled:opacity-50"
        >
          {submitting ? "Authenticating..." : "Log In"}
        </button>
        <p className="font-mono-acc text-[10px] text-muted-foreground">
          No account?{" "}
          <Link to="/register" data-testid="goto-register" className="text-secondary hover:underline">
            Sign up
          </Link>
        </p>
      </form>
    </div>
  );
}
